// @ts-check

export default class CsvParser {
  /** @type {string[][]} */
  table = [];
  /** @param {string} csv */
  constructor(csv) {
    csv = csv.trim();
    this.csv = csv;
    for (const row of csv.split(/\r?\n/)) {
      this.table.push(this.#parseRow(row));
    }
    const rowLength = this.table[0].length;
    if (this.table.some((row) => row.length !== rowLength)) {
      throw new Error("Invalid CSV. Rows have different lengths.");
    }
  }

  get headers() {
    return this.table[0];
  }

  /**
   * @param {number | string} column
   * @param {number} row
   * @returns {string | undefined}
   */
  cell(column, row) {
    const colIndex = typeof column === "number" ? column : this.headers.indexOf(column);
    return this.table[row][colIndex];
  }

  /**
   *
   * @param {string} rowText row of a csv file without the newline character
   * @param {string[]} [currentValues]
   * @returns {string[]}
   */
  #parseRow(rowText, currentValues = []) {
    if (!rowText) return currentValues;
    if (rowText.startsWith('"')) {
      let nextValue = "";
      for (let i = 1; i < rowText.length; i++) {
        if (rowText[i] === '"') {
          if (rowText[i + 1] === '"') {
            nextValue += '"';
            i++;
          } else {
            currentValues.push(nextValue);
            return this.#parseRow(rowText.slice(i + 2), currentValues);
          }
        } else {
          nextValue += rowText[i];
        }
      }
      throw new Error("Invalid CSV. Missing closing quote.");
    } else {
      const nextCommaIndex = rowText.indexOf(",");
      let nextValue = rowText;
      let nextRowText = "";
      if (nextCommaIndex !== -1) {
        nextValue = rowText.slice(0, nextCommaIndex);
        nextRowText = rowText.slice(nextCommaIndex + 1);
      }
      currentValues.push(nextValue);
      return this.#parseRow(nextRowText, currentValues);
    }
  }
}
